import { Component, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { NgClass, DatePipe } from '@angular/common';
import { MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle, MAT_DIALOG_DATA } from '@angular/material/dialog';

import * as dao from '../shared/dao';
import * as utils from '../shared/utils';

import * as constants from '../shared/constants';

export interface DialogData {
  index: number;
  beneficiaire: dao.Beneficiaire;
}

@Component({
  selector: 'lib-recipient',
  imports: [],
  templateUrl: './recipient.component.html',
  styleUrls: ['./recipient.component.scss', '../../../../fseclient/src/styles.scss', '../bs-dialog/bs-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class RecipientComponent {
  public utils = utils; // Export to html view
  public constants = constants;
  public beneficiaire: dao.Beneficiaire | undefined;
  readonly dialogdata = inject<DialogData>(MAT_DIALOG_DATA as any); // 'as any' tricks the compiler

  constructor(private dialog: MatDialog) {}

  ngOnInit() {
    this.beneficiaire = this.dialogdata.beneficiaire;
  }
}
